import { required, minLength } from '@vuelidate/validators';
import { validationI18n } from '../../validation-i18n';
import type { RouteState } from '../types';

type PartialRoute = Partial<RouteState>;
export type Direction = PartialRoute['arr'];

const extractCityCode = (code: string) => {
  /**
   * the first 3 letters are the city code, example: MOWDME. MOW is city code, DME is airport code.
   * For validation we must be sure that the cities do not match, so we take only the city code.
   */
  return code.slice(0, 3);
};
const isSameAirports = (dep: Direction, arr: Direction) =>
  !dep || !arr || extractCityCode(dep.code) !== extractCityCode(arr.code);

const getCitiesValidation = (messageRootPath: string) => {
  const { withI18nMessage } =
    validationI18n.model.useLocalizedValidators(messageRootPath);

  return {
    dep: {
      code: {
        requiredDep: withI18nMessage(required),
      },
      isSameDeparture: withI18nMessage(
        (dep: Direction, route: RouteState) =>
          route && isSameAirports(dep, route.arr),
      ),
    },
    arr: {
      code: {
        requiredArr: withI18nMessage(required),
      },
      isSameArrival: withI18nMessage(
        (arr: Direction, route: RouteState) =>
          route && isSameAirports(arr, route.dep),
      ),
    },
  };
};

const getRouteValidation = (messageRootPath: string) => {
  const { withI18nMessage } =
    validationI18n.model.useLocalizedValidators(messageRootPath);

  return {
    ...getCitiesValidation(messageRootPath),
    dates: {
      requiredDate: withI18nMessage(required),
      minLength: minLength(1),
    },
  };
};

export const searchFormValidation = {
  getRouteValidation,
  getCitiesValidation,
};
